import { Component } from '@angular/core';
import { CustomCheckboxComponent } from '../../../shared-components/custom-checkbox/custom-checkbox.component';
import { TranslateService } from '../../../services/translate/translate.service';

@Component({
	selector: 'app-checkboxes',
	templateUrl: './checkboxes.component.html',
	styleUrls: ['./checkboxes.component.scss'],
	standalone: false,
})
export class CheckboxesComponent {
	primaryValue: string = '';
	successValue: string = '';
	infoValue: string = '';
	warningValue: string = '';
	dangerValue: string = '';
	disabledValue: string = '';
	validationValid = false;
	requiredCheckboxRules: any[] = [];

	constructor(private translateService: TranslateService) {
		this.requiredCheckboxRules = [CustomCheckboxComponent.createRules(this.translateService).required('You must accept the terms')];
	}

	onValidationChange(validation: { isValid: boolean; errors: string[] }): void {
		this.validationValid = validation.isValid;
	}

	onCheckboxChange(checkboxName: string, checked: boolean): void {
		console.log(`Custom checkbox changed: ${checkboxName} = ${checked}`);

		if (checkboxName === 'Primary') {
			this.primaryValue = checked ? 'Accepted' : 'Not accepted';
		} else if (checkboxName === 'Success') {
			this.successValue = checked ? 'Confirmed' : 'Pending';
		} else if (checkboxName === 'Info') {
			this.infoValue = checked ? 'Enabled' : 'Disabled';
		} else if (checkboxName === 'Warning') {
			this.warningValue = checked ? 'Proceed' : 'Cancel';
		} else if (checkboxName === 'Danger') {
			this.dangerValue = checked ? 'Delete' : 'Keep';
		} else if (checkboxName === 'Disabled') {
			this.disabledValue = checked ? 'Active' : 'Inactive';
		}
	}
}
